import './one-dentist.css'
// import { Switch, Route, Link} from 'react-router-dom';
import {
    Container,
    Card,
    Col,
    Row,
    Image,
    Button,
    Badge
} from "react-bootstrap";
// import axios from 'axios';
import React, { useState, useEffect } from "react";
import axios from 'axios';
import SimpleMap from '../../home-page/google-maps/google-maps';
// import { LinkContainer } from 'react-router-bootstrap';
import TimeTable from '../time-table/time-table';
import BookTimeModal from '../../clinic-system/view-clinic/modals/book-time-modal'
import PatientInfoModal from '../../clinic-system/view-clinic/modals/patient-info-modal';
import ReviewModal from '../../clinic-system/view-clinic/modals/review-modal'
import ResultModal from '../../clinic-system/view-clinic/modals/result-modal';
import ReactGA from 'react-ga';
import DisplayReview from './display-review'

const getLanguageString = (languages_spoken) => {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    let string = '';
    if (languages_spoken.length === 1) {
        return languages_spoken[0];
    } else {
        for (let i = 0; i < languages_spoken.length - 1; i++){
            string += (languages_spoken[i] + ', ')
        }
        string += languages_spoken[languages_spoken.length - 1];
        return string;
    }
}

export default function OneDentist(props) {

    console.log(props);
    const dentist_id = props.location.state.dentist._id;
    const dhaUniqueId = props.location.state.dentist.dhaUniqueId
    const [showBookTimeModal, setShowBookTimeModal] = useState(false);
    const [showPatientInfoModal, setShowPatientInfoModal] = useState(false);
    const [showReviewModal, setShowReviewModal] = useState(false);
    const [showResultModal, setShowResultModal] = useState(false);
    const [bookingTime, setBookingTime] = useState(null);
    const [bookingData, setBookingData] = useState(null);
    const [dentist, setDentist] = useState(props.location.state.dentist);
    const languageString = getLanguageString(props.location.state.dentist.languages_spoken);
    const [image, setImage] = useState(props.location.state.dentist.picture_url);

    console.log(props.location.state.dentist)

    const bookTime = () => {
        setShowBookTimeModal(true);
    };

    useEffect( () => {
        if(dhaUniqueId){
            axios.post("https://uae-dentist-backend.herokuapp.com/staff/get-image", {dhaUniqueId})
            .then(result => {
                // console.log();
                // console.log(URL.createObjectURL(result.data))
                setImage('data:image/jpeg;base64,'+ result.data);
            })
        }
        if(dentist_id){
            axios.post("https://uae-dentist-backend.herokuapp.com/staff/get-reviews", {dentist_id})
            // axios.post("http://localhost:5000/staff/get-reviews", {dentist_id})
            .then(dentist => {
                if (dentist.data.reviews.length>0){
                    setDentist(dentist.data);
                }
            })
        }
      }, [dhaUniqueId, dentist_id]);

    const clinicData = props.location.state.clinic;
    // const backup_picture_url ="https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/600px-No_image_available.svg.png"

        return (
            <Container className='mt-5'>
                <Row sm={1} md={3} lg={4}>
                    <Col sm={8} md={4} lg={3}>
                        <Image className='justify-content-center border shadow' src={image} fluid thumbnail />
                    </Col>
                    <Col sm={12} md={8} lg={9}>
                        <Row sm={1} md={1} lg={1}>
                        <Card className="text-center py-3 px-3" size='lg'>
                            <h1>
                                {dentist.full_name}
                            </h1>
                            <h6>
                                {dentist.work_title}
                            </h6>
                        </Card>
                        </Row>
                        <Row className="my-5">
                        <Col sm={4} md={3} lg={2}>
                            <Button
                                className="rounded-pill align-bottom"
                                variant="info"
                                block
                                onClick={() => bookTime()}
                                >
                                Book Now
                            </Button>
                            </Col>
                            <Col sm={8} md={5} lg={9}>
                                <h5 className="rounded-pill float-right align-bottom align-text-bottom">
                                    Languages spoken: {languageString}
                                </h5>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                
                <Row sm={1} md={3} lg={4}>
                    <Col sm={12} md={4} lg={3} >
                        <Card className="card mb-3">
                                <Card.Header className='font-weight-bold'>
                                    Location
                                </Card.Header>
                                { clinicData &&
                                    <SimpleMap clinic={clinicData}/>
                                }

                                <Card.Body>
                                {/* <Card.Text > */}
                                {  clinicData && clinicData.opening_hours &&
                                    <TimeTable opening_hours={clinicData.opening_hours}/>
                                }

                                {/* </Card.Text> */}
                                </Card.Body>
                            </Card>
                            {  clinicData &&
                            <Card className="card mb-3">
                                <Card.Header className='font-weight-bold'>
                                    Services Offered
                                </Card.Header>
                                <Card.Body>
                                <Card.Text >
                                    {clinicData.offered_services.map(service => (<Badge key={service}className="m-1 p-2" variant="info">{service}</Badge>))}
                                </Card.Text>
                                </Card.Body>
                            </Card>
                            }
                    </Col>
                    <Col sm={12} md={8} lg={9} className='p-0'>
                            <Card className="card">
                                <Card.Header className='font-weight-bold'>
                                    Introduction
                                </Card.Header>
                                <Card.Body>

                                {dentist.biography &&
                                    <>
                                    <Card.Text className='font-weight-bold' >
                                        Biography
                                    </Card.Text>
                                    <Card.Text >
                                        {dentist.biography}
                                    </Card.Text>
                                    </>
                                }
                                {dentist.specialities &&
                                    <>
                                    <Card.Text className='font-weight-bold' >
                                        Specialities
                                    </Card.Text>
                                    <Card.Text >
                                        {dentist.specialities}
                                    </Card.Text>
                                    </>
                                }
                                {dentist.experience &&
                                    <>
                                    <Card.Text className='font-weight-bold' >
                                        Experience
                                    </Card.Text>
                                    <Card.Text >
                                        {dentist.experience}
                                    </Card.Text>
                                    </>
                                }
                                {dentist.education &&
                                    <>
                                    <Card.Text className='font-weight-bold' >
                                     Education
                                    </Card.Text>
                                    <Card.Text>
                                        {dentist.education}
                                    </Card.Text>
                                    </>
                                }
                                </Card.Body>
                            </Card>
                            {/* <Image className="my-4" src={`${image_url}`} rounded fluid /> */}
                            {dentist.reviews && dentist.reviews.length > 0 && dentist.reviews[0].rating &&
                            dentist.reviews.map((review) => (
                                <DisplayReview review={review}/>
                            ))
                            }
                        </Col> 
                    </Row>

            { showBookTimeModal &&
                <BookTimeModal 
                clinicData={clinicData} 
                setShow={setShowBookTimeModal} 
                setShowNextModal={setShowPatientInfoModal} 
                setBookingTime={setBookingTime}
                setDentist={setDentist}
                />
            }
            { showPatientInfoModal &&
                <PatientInfoModal 
                setShow={setShowPatientInfoModal}
                setShowNextModal={setShowReviewModal} 
                bookingTime={bookingTime}
                dentist={dentist}
                setBookingData={setBookingData}
                />
            }
            { showReviewModal &&
                <ReviewModal 
                clinicData={clinicData} 
                setShow={setShowReviewModal}
                setShowNextModal={setShowResultModal} 
                bookingData={bookingData}
                setBookingData={setBookingData}
                />
            }
            { showResultModal &&
                <ResultModal 
                setShow={setShowResultModal}
                clinicData={clinicData}
                bookingData={bookingData}
                />
            }
            </Container>
        );
      }
    